const wapHost = 'dshui.com' // 网页版域名
// const wapHost = 'dsh315.com'
export default {
  
  WAP_HOST: wapHost, // 网页版域名

  API_HOST_MAIN: 'https://www.dshui.cc', // API接口域名
  API_HOST_TB: 'https://h5api.m.taobao.com/h5', // 淘宝官方域名
  API_HOST_SHORTURL: 'https://dshui.vip/api/v1', // 短链接域名
  API_HOST_WX: `https://wx.${wapHost}`, // 微信中控服务器

  CART_NAME: 'DSH_CART', // 购物车存储在store中的名称

  TB_AUTH_APPKEY: 27838312, // 淘宝联盟授权-AppKey
  TB_AUTH_CALLBACK_HOST: `https://pub.${wapHost}`, // 淘宝联盟-应用注册时填写的回调地址域名
  // TB_AUTH_CALLBACK_HOST: 'http://frp.sufaith.com', // 淘宝联盟-应用注册时填写的回调地址域名
  TB_AUTH_PAGE_VIEW_TYPE: 'wap', // 淘宝联盟-Wap对应无线端的浏览器页面样式
  TB_AUTH_GET_CODE_URL: 'https://oauth.taobao.com/authorize', // 淘宝联盟-获取授权码（code）

  STORE_DOING_LOGIN: 'DSH_DOING_LOGIN', // 表明正在登录
  STORE_ROUTE_STACK: 'DSH_ROUTE_STACK', // 路由栈
  STORE_SHARE_PRODUCT: 'DSH_SHARE_PRODUCT', // 需要分享的商品实例

  STORE_HISTORY_SEARCH: 'DSH_HISTORY_SEARCH', // 历史搜索
  STORE_PDD_HISTORY_SEARCH: 'DSH_PDD_HISTORY_SEARCH', // 历史搜索(拼多多)
  STORE_JD_HISTORY_SEARCH: 'DSH_JD_HISTORY_SEARCH', // 历史搜索(京东)
  STORE_VPH_HISTORY_SEARCH: 'DSH_VPH_HISTORY_SEARCH', // 历史搜索(唯品会)
  STORE_SEARCH_GOODS_DATA: 'DSH_SEARCH_GOODS_DATA', // 搜索的商品详情(保存起来, 在商品详情页展示)


  COOKIE_USER_LOGIN_TYPE: 'DSH_USER_LOGIN_TYPE', // 用户登录方式, wechat:微信授权登录 account:账号密码登录
  COOKIE_USER_WX_UNIONID: 'DSH_USER_WX_UNIONID', // 用户微信unionid
  COOKIE_USER_TOKEN: 'DSH_USER_TOKEN', // 用户登陆令牌
  COOKIE_USER_UNIONID: 'DSH_USER_UNIONID', // 用户邀请码
  COOKIE_USER_MOBILE: 'DSH_USER_MOBILE', // 用户手机号
  COOKIE_USER_MD5_PWD: 'DSH_USER_PWD', // 用户加密后的密码
  COOKIE_USER_INFO: 'DSH_USER_INFO', // 用户信息
  COOKIE_INVITER_UNIONID: 'DSH_INVITER_UNIONID', // 推广人的邀请码

  COOKIE_AUTH_TB_ACCOUNT_NAME: 'COOKIE_AUTH_TB_ACCOUNT_NAME', // 授权的淘宝账户名称
  COOKIE_AUTH_TB_ACCOUNT_RELATION_ID: 'COOKIE_AUTH_TB_ACCOUNT_RELATION_ID', // 授权的淘宝账户关联ID
}
